import { Address, Hex } from 'viem';

import { getActiveNetwork } from '@/lib/network/getActiveNetwork';
import { E_Network } from '@/ts/enums/E_Network';

export const C_USDC_ADDRESSES: Record<E_Network, Hex> = {
  [E_Network.SEPOLIA]: '0x56254B81187fb04FF5D146aE29E3daDa56C40f62',
  [E_Network.BASE]: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  [E_Network.BASE_SEPOLIA]: '0x2ad3140D1DB7569abD131CF0E84B44f488D9eE86'
};

export const C_USDC_CONTRACT = C_USDC_ADDRESSES[getActiveNetwork()] as Address;
